import { HoldingsConcentration } from 'actions';

const initialState = {
  holdings: [],
  isFetching: false,
  accounts: [],
  preSelectedAccounts: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case HoldingsConcentration.HOLDINGS_CONCENTRATION_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case HoldingsConcentration.HOLDINGS_CONCENTRATION_FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        holdings: action.holdings,
        accounts: action.accounts,
      };
    case HoldingsConcentration.HOLDINGS_CONCENTRATION_FETCH_FAIL:
      return {
        ...state,
        isFetching: false,
      };
    case HoldingsConcentration.HOLDINGS_CONCENTRATION_CLEAR:
      return initialState;
    case HoldingsConcentration.HOLDINGS_CONCENTRATION_SET_SELECTED_ACCOUNTS:
      return {
        ...state,
        preSelectedAccounts: action.accounts,
      };
    default:
      return state;
  }
}
